// Ordered list of furniture categories the customer can choose from.
// Keep the slug stable; it's stored in the DB.
export const CATEGORIES = [
  { slug: "armoire", name: "Armoire" },
  { slug: "bedframe", name: "Bedframe" },
  { slug: "cabinet", name: "Cabinet" },
  { slug: "chest", name: "Chest" },
  { slug: "coffee-table", name: "Coffee Table" },
  { slug: "desk", name: "Desk" },
  { slug: "dining-chair", name: "Dining Chair" },
  { slug: "dining-table", name: "Dining Table" },
  { slug: "dresser", name: "Dresser" },
  { slug: "hutch", name: "Hutch" },
  { slug: "sideboard", name: "Sideboard" },
  { slug: "sidetable", name: "Sidetable" },
];

export const CATEGORY_BY_SLUG = Object.fromEntries(
  CATEGORIES.map((c) => [c.slug, c.name]),
);

export const categoryName = (slug) => CATEGORY_BY_SLUG[slug] || slug || "Uncategorised";
